import { Injectable } from '@angular/core';

// import '@recruitee/redactor/_plugins/alignment/alignment.js';

import { Redactor, RedactorApp, RedactorConfig } from '../../redactor.types';
import { RedactorPlugin } from '../interfaces';
import { RedactorExtension } from '../redactor-extension';

declare let $R: Redactor;
const ALIGNMENT_BUTTONS_PLUGIN_TOKEN = 'rt-alignment-buttons';

/*
 * This plugin requires redactor plugin.alignment to work correctly
 */
export class AlignmentButtons implements RedactorPlugin {
  private lang: any;
  private toolbar: any;

  public init({ lang, toolbar }: RedactorApp): void {
    this.lang = lang;
    this.toolbar = toolbar;
  }

  public start(): void {
    const buttons = [
      {
        name: 'align-left',
        title: this.lang.get('align-left'),
        icon: `<i class="re-icon-alignleft"></i>`,
        api: 'plugin.alignment.set',
        args: 'left',
      },
      {
        name: 'align-center',
        title: this.lang.get('align-center'),
        icon: `<i class="re-icon-aligncenter"></i>`,
        api: 'plugin.alignment.set',
        args: 'center',
      },
      {
        name: 'align-right',
        title: this.lang.get('align-right'),
        icon: `<i class="re-icon-alignright"></i>`,
        api: 'plugin.alignment.set',
        args: 'right',
      },
    ];

    buttons.forEach(({ name, icon, ...button }) => {
      const redactorButton = this.toolbar.addButton(name, button);
      redactorButton.setIcon(icon);
    });

    const alignmentDropdownButton = this.toolbar
      .getButtons()
      .find(({ name }: any) => name === 'alignment')!;
    alignmentDropdownButton.remove();
  }
}

@Injectable({ providedIn: 'root' })
export class RedactorAlignmentButtonsExtension extends RedactorExtension {
  constructor() {
    super();

    $R.add('plugin', ALIGNMENT_BUTTONS_PLUGIN_TOKEN, new AlignmentButtons());
  }

  public canInstall(config: RedactorConfig): boolean {
    return config.plugins!.includes(ALIGNMENT_BUTTONS_PLUGIN_TOKEN);
  }

  public install(config: RedactorConfig): RedactorConfig {
    this.enable();
    const plugins = config.plugins || [];
    const hasAlignmentPlugin = plugins.includes('alignment');
    const cfg = {
      ...config,
      plugins: hasAlignmentPlugin
        ? [...plugins].sort((a, b) => (a === 'alignment' ? -1 : 1))
        : ['alignment', ...plugins],
    };

    return cfg;
  }
}
